export default {
  default: () => import("/var/www/mj_client/releases/20251110070554/layouts/default.vue").then(m => m.default || m),
  simple: () => import("/var/www/mj_client/releases/20251110070554/layouts/simple.vue").then(m => m.default || m)
}